import { useState, useRef, useEffect } from 'react';
import cn from 'bem-cn';

import { Video } from '../../UI';
import { ScreenSize, useGetScreenSize } from '../../../hooks';
import { CategorySelectorItemProps } from './CategorySelectorItem.types';
import './CategorySelectorItem.scss';

const b = cn('category-selector-item');

export const CategorySelectorItem = ({
    name,
    image,
    video,
    size,
    variant = 'default',
    checked = false,
    disabled = false,
    forceHover = false,
    onClick,
    onMouseEnter: onMouseEnterProp,
    onMouseLeave: onMouseLeaveProp,
}: CategorySelectorItemProps) => {
    const [isHovered, setIsHovered] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);
    const screenSize = useGetScreenSize();

    // Отключаем видео на Mobile и Tablet
    const isVideoEnabled = screenSize !== ScreenSize.Mobile && screenSize !== ScreenSize.Tablet;

    // Используем forceHover или локальный isHovered
    const shouldShowVideo = (forceHover || isHovered) && isVideoEnabled;

    // Эффект для управления видео при изменении forceHover
    useEffect(() => {
        if (video && videoRef.current) {
            if (shouldShowVideo) {
                videoRef.current.play().catch(() => {
                    // Игнорируем ошибки автовоспроизведения
                });
            } else {
                videoRef.current.pause();
                videoRef.current.currentTime = 0;
            }
        }
    }, [shouldShowVideo, video]);

    const handleMouseEnter = () => {
        setIsHovered(true);

        if (video && videoRef.current) {
            videoRef.current.play().catch(() => {
                // Игнорируем ошибки автовоспроизведения
            });
        }

        onMouseEnterProp?.();
    };

    const handleMouseLeave = () => {
        setIsHovered(false);

        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }

        onMouseLeaveProp?.();
    };

    const handleClick = () => {
        if (!disabled && onClick) {
            onClick();
        }
    };

    const showVideo = shouldShowVideo && video && isVideoEnabled;

    return (
        <div
            className={b({ size, variant, checked, disabled })}
            onClick={handleClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className={b('icon-wrapper')}>
                <img src={image} alt={name} className={b('icon')} style={{ opacity: showVideo ? 0 : 1 }} />
                {video && (
                    <Video
                        ref={videoRef}
                        src={video}
                        muted
                        loop
                        playsInline
                        preload="auto"
                        className={b('video')}
                        style={{ opacity: showVideo ? 1 : 0 }}
                    />
                )}
            </div>
            <span className={b('name')}>{name}</span>
        </div>
    );
};
